/** Shimmering placeholder rows while a query loads (announced once as "Loading"). */
export function Skeleton({
  lines = 3,
  className = '',
  label = 'Loading',
}: {
  lines?: number;
  className?: string;
  label?: string;
}) {
  return (
    <div role="status" aria-live="polite" className={`flex flex-col gap-2.5 ${className}`}>
      <span className="sr-only">{label}…</span>
      {Array.from({ length: lines }, (_, i) => (
        <span
          key={i}
          aria-hidden
          className="skeleton block h-4"
          style={{ width: `${[92, 76, 84, 64, 88][i % 5]}%` }}
        />
      ))}
    </div>
  );
}

/** Card-shaped skeletons for grids (recipe cards, planner days). */
export function SkeletonCards({
  count = 6,
  className = '',
  label = 'Loading',
}: {
  count?: number;
  className?: string;
  label?: string;
}) {
  return (
    <div role="status" aria-live="polite" className={className}>
      <span className="sr-only">{label}…</span>
      {Array.from({ length: count }, (_, i) => (
        <div key={i} aria-hidden className="card overflow-hidden">
          <div className="skeleton aspect-[16/9] rounded-none sm:aspect-[4/3]" />
          <div className="flex flex-col gap-2 p-4">
            <span className="skeleton block h-4 w-3/4" />
            <span className="skeleton block h-3 w-1/2" />
          </div>
        </div>
      ))}
    </div>
  );
}
